import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit {
  readonly MAX_RATING = 5;

  @Input() set setRating(rating: number) {
    this.rating = rating;
    this.ratingArray = new Array(this.MAX_RATING).fill(null).map((_, index) => {
      const roundDiff = Math.round((rating - index) * 2) / 2;
      return roundDiff >= 1 ? 'star' : roundDiff === 0.5 ? 'star_half' : 'star_border';
    });
  }
  @Input() showExact: boolean = false;

  rating: number;
  ratingArray: string[];

  constructor() { }

  ngOnInit() {
  }

}
